"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Remove = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Remove = ({
  code,
  disabled,
  onRemoveButtonClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const onClickHandler = (0, _react.useCallback)(event => {
    event.preventDefault();
    event.stopPropagation();
    if (onRemoveButtonClick) {
      onRemoveButtonClick();
    }
  }, [onRemoveButtonClick]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconButtonWithFixedSize, {
    buttonSize: _constants2.REMOVE_ICON_BUTTON_SIZE,
    "data-testid": `${getTestId(_constants.REMOVE)}-${code}`,
    disabled: disabled,
    iconSize: _constants2.REMOVE_ICON_BUTTON_ICON_SIZE,
    variant: "contained",
    color: "default",
    onClick: onClickHandler,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {
      fontSize: "inherit"
    })
  });
};
exports.Remove = Remove;
//# sourceMappingURL=Remove.js.map